import { BasicRequest } from "./basicRequest";

export class PublishConsolidationDefinitionRequest extends BasicRequest{
    public consolidationDefinitionId!:number;
    public published:boolean = false;

    constructor(){
        super();
    }
}